<template>
  <div :class="classDivCont" 
    v-for="{ label, name, type, rules, id } in schema.fields" :key="id"
  >
    <label :for="name" :class="classLabel">{{ label }}</label>
    <div :class="classDivField">
      <Field :name="name" :type="type" class="form-control" :rules="rules" />
      <ErrorMessage :name="name" class="error-feedback" />
    </div>
  </div>
</template>

<script>
import { Field, ErrorMessage } from "vee-validate";

export default {
  name: 'Field-l-fe',
  components: {
    Field,
    ErrorMessage,
  },
  props: {
    schema: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      classDivCont: this.schema.classDivCont,   // class="form-group row"
      classLabel: this.schema.classLabel,       // class="col-sm-4"
      classDivField: this.schema.classDivField, // class="d-flex align-items-end flex-column col-sm-8"
    }
  },
}
</script>

<style >
.error-feedback {
  margin-right: 5px;
  color:red;
}
</style>